export default __webpack_public_path__ + "static/brush-stroke-pink-313d46747b94f4123d7ecff6dcc57a28.svg";